import { z } from 'zod';
/** Admin RBAC roles (06-security-architecture.md, Q-08). */
export const ADMIN_ROLES = [
    'SUPER_ADMIN',
    'CONTENT_MANAGER',
    'MARKETING_MANAGER',
    'NOTIFICATION_MANAGER',
    'APPROVER',
];
export const AdminRoleSchema = z.enum(ADMIN_ROLES);
/** `admin_users.status`. */
export const ADMIN_USER_STATUSES = ['ACTIVE', 'DISABLED'];
export const AdminUserStatusSchema = z.enum(ADMIN_USER_STATUSES);
/** `app_users.status`. */
export const APP_USER_STATUSES = ['ACTIVE', 'DELETION_REQUESTED', 'DELETED'];
export const AppUserStatusSchema = z.enum(APP_USER_STATUSES);
/** `app_users.gender`; optional field (Q-09). */
export const GENDERS = ['MALE', 'FEMALE', 'PREFER_NOT_TO_SAY'];
export const GenderSchema = z.enum(GENDERS);
/** `app_users.state`: South African province codes (Q-10); ads target them in `targetLocations`. */
export const PROVINCES = ['EC', 'FS', 'GP', 'KZN', 'LP', 'MP', 'NC', 'NW', 'WC'];
export const ProvinceSchema = z.enum(PROVINCES);
/** `app_users.crm.syncStatus`. */
export const CRM_SYNC_STATUSES = ['PENDING', 'SYNCED', 'FAILED', 'DISABLED'];
export const CrmSyncStatusSchema = z.enum(CRM_SYNC_STATUSES);
/** `crm_sync_log.event`. */
export const CRM_SYNC_EVENTS = ['REGISTERED', 'UPDATED', 'DELETED'];
export const CrmSyncEventSchema = z.enum(CRM_SYNC_EVENTS);
/** `otp_challenges.purpose`. */
export const OTP_PURPOSES = ['LOGIN', 'SIGNUP', 'CHANGE_PHONE'];
export const OtpPurposeSchema = z.enum(OTP_PURPOSES);
/** `refresh_tokens.subjectType`. */
export const TOKEN_SUBJECT_TYPES = ['ADMIN', 'APP_USER', 'GUEST'];
export const TokenSubjectTypeSchema = z.enum(TOKEN_SUBJECT_TYPES);
/** `devices.platform`. */
export const DEVICE_PLATFORMS = ['IOS', 'ANDROID'];
export const DevicePlatformSchema = z.enum(DEVICE_PLATFORMS);
//# sourceMappingURL=identity.js.map